import React, { Component } from "react";

class SimpleLayout extends Component {
  render() {
    return <div className="page__wrapper">{this.props.children}</div>;
  }
}
export default SimpleLayout;
